<template>
  <div>
    <!-- 添加银行 -->
    <el-form
      style="width: 100%"
      ref="ruleFormRef"
      :model="ruleForm"
      label-width="100px"
      :rules="rules"
      class="demo-ruleForm"
      status-icon
      label-position="right"
    >
      <el-form-item label="姓名" prop="realName">
        <el-input v-model="ruleForm.realName" placeholder="请输入姓名" />
      </el-form-item>

      <el-form-item label="身份证号" prop="idCard">
        <el-input v-model="ruleForm.idCard" placeholder="请输入身份证号" />
      </el-form-item>
      <el-form-item label="开户行" prop="bankName">
        <!-- <el-input v-model="ruleForm.bankName" placeholder="请输入开户行" /> -->
        <el-select v-model="ruleForm.bankName" placeholder="请选择开户行" clearable>
            <el-option :label="item" :value="item" v-for="(item, index) in khhList" :key="index"/>
        </el-select>
      </el-form-item>
      <el-form-item label="卡类型" prop="bankType">
        <el-select v-model="ruleForm.bankType" placeholder="请选择卡类型" clearable>
            <el-option :label="item.name" :value="item.value" v-for="(item, index) in kkindList" :key="index"/>
        </el-select>
      </el-form-item>
      <el-form-item label="支行名称" prop="bankBranch">
        <el-input v-model="ruleForm.bankBranch" placeholder="请输入支行名称" />
      </el-form-item>
      <el-form-item label="银行卡号" prop="bankNo">
        <el-input v-model="ruleForm.bankNo" placeholder="请输入银行卡号" />
      </el-form-item>

      <el-form-item label="预留手机号" prop="mobile">
        <el-input v-model="ruleForm.mobile" placeholder="请输入预留手机号" />
      </el-form-item>
    </el-form>
    <div style="font-size: font-size: 0.14rem;;">
      <el-checkbox
        v-model="allCheckbox"
        size="large"
        style="margin-right: 0.06rem"
      />同意<span style="color: #C01A26" @click="openagreement('bdyhkyhxy')">《绑定银行卡用户协议》</span>
    </div>
    <div class="cardBnt" @click="submit">确认添加</div>
  </div>
</template>

<script lang="ts" setup>
import { reactive, nextTick, ref } from "vue";
import { ElMessage } from "element-plus";
import type { FormInstance, FormRules } from "element-plus";
import { Axios } from "@/assets/js/ls_com_axios.js";
const allCheckbox = ref(false);
const emit = defineEmits(["submit"]);
const ruleForm = ref({
  realName: "",
  idCard: "",
  bankName: "",
  bankType: "",
  bankBranch: "",
  bankNo: "",
  mobile: "",
});
const khhList = ref([
  '中信银行','中国银行','招商银行','邮政银行','兴业银行','齐商银行','浦发银行','农业银行','交通银行','建设银行','微商银行','华夏银行','农村信用社银行','光大银行','工商银行','东亚银行','华侨银行','中国平安银行','民生银行','其他'
])
const kkindList = ref([
  {
    name: '储蓄卡',
    value: 'DEBITCARD'
  },
  {
    name: '信用卡',
    value: 'CREDITCARD'
  },
  {
    name: '支付宝',
    value: 'ALIPAY'
  },
  {
    name: '微信',
    value: 'WECHAT'
  },
])
// 校验
const rules = reactive<FormRules>({
  realName: [{ required: true, message: "不能为空！", trigger: "change" }],
  idCard: [{ required: true, message: "不能为空！", trigger: "change" }],
  bankName: [{ required: true, message: "不能为空！", trigger: "input" }],
  bankType: [{ required: true, message: "不能为空！", trigger: "input" }],
  bankBranch: [{ required: true, message: "不能为空！", trigger: "change" }],
  bankNo: [{ required: true, message: "不能为空！", trigger: "change" }],
  mobile: [{ required: true, message: "不能为空！", trigger: "change" }],
});
const ruleFormRef = ref<any>();
const submit = () => {
  if (allCheckbox.value) {
    ruleFormRef.value.validate((valid: boolean) => {
      if (valid) {
        Axios("post", "/member/member-bank", ruleForm.value, false, (res) => {
          emit("submit");
          resetForm(ruleFormRef.value);
        });
      } else {
        ElMessage.warning("请填写完整信息");
      }
    });
  } else {
    ElMessage.warning("请勾选同意《绑定银行卡用户协议》");
  }
};
const init = async () => {
  ruleForm.value = {
    realName: "",
    idCard: "",
    bankName: "",
    bankBranch: "",
    bankNo: "",
    mobile: "",
  };
  allCheckbox.value = false;
  await nextTick();
  ruleFormRef.value.resetFields();
};
const resetForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  init();
  formEl.resetFields();
};
const openagreement = (val) =>{
  window.open(`/agreement?name=${val}`,'_bank')
}
defineExpose({ init });
</script>

<style scoped>
.cardBnt {
  width: 100%;
  height: 0.53rem;
  line-height: 0.53rem;
  margin-top: 0.2rem;
  background: #C01A26;
  color: #fff;
  text-align: center;
  border-radius: 0.12rem 0.12rem 0.12rem 0.12rem;
  opacity: 1;
}
/deep/.el-select{
  width: 100%;
}
</style>
